import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_BUSINESS, LEGAL_BUSINESS_SHORT } from "../pages/Legal";

/* Small editorial footer shown at the base of long pages (Home, Profile).
   Mentions the parent business + legal owner so domain/payment-gateway compliance
   reviewers (Cashfree, Razorpay) can see business identity at a glance. */
export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="px-2 pt-5 pb-2 text-center" data-testid="legal-footer">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-[hsl(var(--muted-foreground))] uppercase tracking-[0.16em]">
        <Link to="/legal?tab=about"   className="hover:text-[hsl(var(--plum))]" data-testid="footer-link-about">About</Link>
        <span className="opacity-30">·</span>
        <Link to="/legal?tab=terms"   className="hover:text-[hsl(var(--plum))]" data-testid="footer-link-terms">Terms</Link>
        <span className="opacity-30">·</span>
        <Link to="/legal?tab=privacy" className="hover:text-[hsl(var(--plum))]" data-testid="footer-link-privacy">Privacy</Link>
        <span className="opacity-30">·</span>
        <Link to="/legal?tab=refund"  className="hover:text-[hsl(var(--plum))]" data-testid="footer-link-refund">Refunds</Link>
        <span className="opacity-30">·</span>
        <Link to="/legal?tab=contact" className="hover:text-[hsl(var(--plum))]" data-testid="footer-link-contact">Contact</Link>
      </div>
      <p className="mt-3 text-[11px] text-[hsl(var(--muted-foreground))]" data-testid="footer-owner">
        © {year} <span className="font-semibold text-[hsl(var(--foreground))]">Knya.ai by {LEGAL_BUSINESS_SHORT}</span>
      </p>
      <p className="text-[10.5px] text-[hsl(var(--muted-foreground))] mt-0.5 opacity-90">
        CIN: U62090MH2026OPC472128
      </p>
      <a
        href="https://knya.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 inline-block text-[10.5px] font-extrabold text-[hsl(var(--primary))] hover:underline tracking-wide"
        data-testid="footer-knya-link"
      >
        knya.ai →
      </a>
    </footer>
  );
}
